export default __webpack_public_path__ + "static/media/jibon-small.64924c05.png";